import templateUrl from './planning-resources-mobility-management.html';
import find from 'lodash/find';
import groupBy from 'lodash/groupBy';
import map from 'lodash/map';

import Highcharts from 'highcharts';
require('highcharts/modules/map')(Highcharts);

export const planningResourcesMobilityManagementComponent = {
    templateUrl,

    bindings: {
        details: '<'
    },
	controller: class PlanningResourcesMobilityManagementComponent {
		constructor($timeout, HighmapsService, ModalService) {
            'ngInject';

            this.$timeout = $timeout;
            this.highmapsService = HighmapsService;
            this.modalService = ModalService;
            this.mapData = this.highmapsService.getCountyData();
            this.colors = ["#ed6d79", "#ff89b5", "#f5a26f", "#90d4f7", "#668de5", "#66d18a"]
        }
    	$onInit() {
            if(this.details.content.length > 0) {
                this.$timeout(() => {
                    this.loadMap(this.details.content);
                })
            }
    	}

        getMapDetails(data) {
            let mapDetails = groupBy(data, 'name');
            var count = 0;
            let details = map(mapDetails, (value, index) => {
                let val = {
                    name: index,
                    data: _getData(value, this.colors[count]),
                    color: this.colors[count]
                }
                count += 1;
                return val;
            })
            function _getData(data, color) {
                return map(data, (value) => {
                    return {
                        name: value.countyName,
                        color: color,
                        description: value.description,
                        groupName: value.name
                    }
                })
            }
            return details;

        }

        loadMap(data) {
            //const imagePath = '/./images/icon-pointer.png';
            // Initiate the chart
            const mapDetails = angular.copy(this.getMapDetails(data));
            let map = angular.element(document.getElementById('county-map'));

            Highcharts.mapChart('county-map', {
                chart: {
                    height: 600,
                    backgroundColor: null
                },
                title: {
                    text: ''
                },
                subtitle: {
                    text: ''
                },
                legend: _getLegendConfig(),
                credits: {
                    enabled: false
                },
                tooltip: _getTooltipConfig(),
                responsive: _getResponsiveConfig(),
                plotOptions: {
                    map: {
                        allAreas: false,
                        cursor: 'pointer',
                        mapData: this.mapData,
                        joinBy: ["name"],
                        dataLabels: _getDataLabelConfig(),
                        point: _getPointEvent.call(this)
                    },
                    series: {
                        events: {
                            legendItemClick: (e) => {
                                return false;
                            }
                        }
                    }
                },
                series: mapDetails
            });

            function _getResponsiveConfig() {
                return {
                    rules: [{
                        condition: {
                            maxWidth: 567
                        },
                        chartOptions: {
                            chart: {
                                height: 400
                            },
                            legend: _getResponsiveLegendConfig(),
                            plotOptions: {
                                map: {
                                    dataLabels: _getResponsiveDataLabelsConfig()
                                }
                            }
                        }
                    }]
                }   
            }

            function _getTooltipConfig() {
                return {
                    backgroundColor: 'rgba(255, 255, 255, .98)',
                    borderWidth: 0,
                    headerFormat: '<h3 class="county-title">{point.key} county</h3>',
                    useHTML: true,
                    shadow: true,
                    padding: 10,
                    pointFormat: "click for view details"
                }
            }

            function _getPointEvent() {
                return {
                    events: {
                        click: (e) => {
                            this.modalService.open({
                                details: {
                                    title: e.point.name,
                                    bodyMessage: e.point.description
                                },

                                buttons: [
                                    {
                                        name: 'x'
                                    }
                                ]
                            });
                        }
                    }
                }
            }

            function _getResponsiveDataLabelsConfig() {
                return {
                    formatter: function () {
                        return `<div class="highchart-label-responsive"><p>${this.point.name}</p></div>`
                    }
                }
            }

            function _getDataLabelConfig() {
                return {
                    useHTML: true,
                    enabled: true,
                    align: "center",
                    y: -8,
                    formatter: function () {
                        return `<div class="highchart-label"><p>${this.point.name}</p></div>`
                    },
                    style: {
                        color: '#fff',
                        fontSize: "11px",
                        fontWeight: "700",
                        textOutline: ''
                    }
                }
            }

            function _getResponsiveLegendConfig() {
                return {
                    title: {
                        style: {
                            fontSize: "13px"
                        }
                    },
                    align: 'center',
                    itemMarginBottom: 5,
                    itemMarginTop: 10,
                    itemStyle: {
                        fontSize: "13px"
                    }
                }
            }

            function _getLegendConfig() {
                return {
                    title: {
                        text: 'Mobility Management Programs',
                        style: {
                            color: "#404041",
                            fontSize: "16px",
                            fontWeight: "400",
                            fontFamily: "Myriad Pro Semibold"
                        }
                    },
                    layout: 'horizontal',
                    align: 'left',
                    verticalAlign: 'bottom',
                    itemMarginBottom: 10,
                    itemMarginTop: 20,
                    itemStyle: {
                        color: "#404041",
                        fontSize: "16px",
                        fontWeight: "400",
                        fontFamily: "Myriad Pro Regular",
                        textTransform: "capitalize"
                    },
                    floating: false,
                    valueDecimals: 0,
                    symbolRadius: 0,
                    symbolPadding: 15,
                    symbolHeight: 20
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/planning-resources-mobility-management/planning-resources-mobility-management.component.js